import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetSolicitudGastosTransporteByID = {
  status: number | null;
  statusText: string | null;
};

const getBackendMessage = (err: any) => {
  const responseData = err?.response?.data;

  return (
    (typeof responseData === "string" ? responseData : null) ||
    responseData?.response ||
    responseData?.message ||
    err?.response?.statusText ||
    err?.message ||
    "Error"
  );
};

const useGetSolicitudGastosTransporteByID = () => {
  const [loadingGetSolicitudGastosTransporteByID, setLoadingGetSolicitudGastosTransporteByID] = useState(false);
  const [successGetSolicitudGastosTransporteByID, setSuccessGetSolicitudGastosTransporteByID] = useState(false);
  const [errorGetSolicitudGastosTransporteByID, setErrorGetSolicitudGastosTransporteByID] = useState<any>(null);
  const [dataGetSolicitudGastosTransporteByID, setDataSolicitudGastosTransporte] = useState<any>(null);
  const [statusGetSolicitudGastosTransporteByID, setStatusGetSolicitudGastosTransporteByID] =
    useState<StatusGetSolicitudGastosTransporteByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getSolicitudGastosTransporteByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetSolicitudGastosTransporteByID(true);
    setSuccessGetSolicitudGastosTransporteByID(false);
    setErrorGetSolicitudGastosTransporteByID(null);

    try {
      const res = await apiRecord.getSolicitudGastosContingenciaProfesionalTransporteByID(userId, prestacionId, id);

      setStatusGetSolicitudGastosTransporteByID({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetSolicitudGastosTransporteByID(true);
      setDataSolicitudGastosTransporte(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      const backendMessage = getBackendMessage(err);

      setStatusGetSolicitudGastosTransporteByID({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetSolicitudGastosTransporteByID(err);
      console.error("Error en getSolicitudGastosTransporteByID:", err);

      throw err;
    } finally {
      setLoadingGetSolicitudGastosTransporteByID(false);
    }
  };

  return {
    getSolicitudGastosTransporteByID,
    loadingGetSolicitudGastosTransporteByID,
    successGetSolicitudGastosTransporteByID,
    errorGetSolicitudGastosTransporteByID,
    dataGetSolicitudGastosTransporteByID,
    statusGetSolicitudGastosTransporteByID
  };
};

export default useGetSolicitudGastosTransporteByID;
